module.exports = __webpack_public_path__ + "media/landing_page/small_top_background_inverted-50a53b99.png";